module.exports = __webpack_public_path__ + "img/easy-chocolate-cannoli-treats.9d0fb3bd.jpg";